import { ColorTokens, DividerSizeTokens, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import React, { memo } from 'react';
import { View } from 'react-native';
const Divider = ({ color = ColorTokens.Grey_Chalk, size = DividerSizeTokens.SM, margin, type, width, height }) => {
    const theme = ThemeProvider.getTheme();
    const customHeight = theme.dividerSize[size];
    const bgColor = theme.colors[color];
    const marginTop = theme.space[margin?.vertical || margin?.top];
    const marginBottom = theme.space[margin?.vertical || margin?.bottom];
    const marginLeft = theme.space[margin?.horizontal || margin?.left];
    const marginRight = theme.space[margin?.horizontal || margin?.right];
    return (React.createElement(View, { style: {
            width: width ? width : '100%',
            backgroundColor: bgColor,
            height: height ? height : customHeight,
            marginTop: marginTop,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight,
            borderColor: bgColor,
            borderStyle: 'solid'
        } }));
};
export default memo(Divider);
export { Divider };
